import { cn } from "@/lib/utils";
import { DispatchStatusEnum, OrderStatusEnum } from "@/types/order";

type Status = OrderStatusEnum | DispatchStatusEnum;

export function StatusTag({ status, variant }: { status: Status; variant?: "success" | "danger" | "warning" }) {
	const statusColor = {
		[OrderStatusEnum.PENDING]: "bg-yellow-200 text-yellow-800",
		[OrderStatusEnum.COMPLETED]: "bg-green-200 text-green-800",
		[OrderStatusEnum.PAID]: "bg-blue-200 text-blue-800",
		[OrderStatusEnum.CANCELED]: "bg-gray-200 text-gray-800",
		[OrderStatusEnum.REJECTED]: "bg-red-200 text-red-800",
		[OrderStatusEnum.EXPIRED]: "bg-red-200 text-red-800",
		[OrderStatusEnum.FAILED]: "bg-red-200 text-red-800",

		[DispatchStatusEnum.Arrived]: "bg-violet-200 text-violet-900",
		[DispatchStatusEnum.Dispatch]: "bg-cyan-200 text-cyan-800",
		[DispatchStatusEnum.InTransit]: "bg-purple-200 text-purple-800",
		[DispatchStatusEnum.Pending]: "bg-yellow-200 text-yellow-800",
		[DispatchStatusEnum.Delivered]: "bg-green-200 text-green-800"
	};

	const variantColor = {
		success: "bg-green-100 text-green-600",
		danger: "bg-red-100 text-red-600",
		warning: "bg-yellow-100 text-yellow-600"
	};

	// Type guard to check if status is a valid OrderStatusEnum or DispatchStatusEnum
	const isValidStatus = (
		status: Status
	): status is OrderStatusEnum | DispatchStatusEnum => {
		return (
			Object.values(OrderStatusEnum).includes(status as OrderStatusEnum)
			|| Object.values(DispatchStatusEnum).includes(status as DispatchStatusEnum)
		);
	};

	if (variant) {
		return (
			<span
				className={cn(
					`rounded-xl px-1.5 py-1 text-xs capitalize leading-none no-underline group-hover:no-underline ${
						variantColor[variant]
					}`
				)}
			>
				{status.toLowerCase()}
			</span>
		);
	}

	if (status && isValidStatus(status)) {
		return (
			<span
				className={cn(
					`rounded-xl px-1.5 py-1 text-xs capitalize leading-none no-underline group-hover:no-underline ${
						statusColor[status]
					}`
				)}
			>
				{status.toLowerCase()}
			</span>
		);
	}

	return null;
}
